import React from 'react';
import styled from 'styled-components';

export const Title: React.FunctionComponent = (props) => <StyledHeader {...props} />;

export const StyledHeader = styled.h1`
  font-size: 30px;
  line-height: 36px;
  font-weight: bold;
  white-space: pre-wrap;
  letter-spacing: 0.2px;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/components/title.component.tsx